import { BusinessCategoryDto } from '@/core/api/dtos/response/businessCategory/businessCategory'
import { BusinessCategory } from '@/core/api/entities/businessCategory'
import { GenericMapper } from '@/core/api/mappers/genericMapper'

export class BusinessCategoryMapper {
	public static toEntity(dto: BusinessCategoryDto): BusinessCategory {
		const parentId = GenericMapper.mapNumber(dto.parent_id)
		const dates = GenericMapper.mapDates({
			createdAt: dto.created_at,
			updatedAt: dto.updated_at,
		})

		const parent = dto.parent?.data
			? BusinessCategoryMapper.toEntity(dto.parent.data)
			: undefined

		return new BusinessCategory({
			id: dto.id,
			parentId,
			key: dto.key,
			name: dto.name,
			nameTranslations: dto.name_translations,
			requiresDescription: dto.requires_description ?? false,
			tags: dto.tags,
			createdAt: dates.createdAt,
			updatedAt: dates.updatedAt,
			parent,
		})
	}

	public static toDTO(entity: BusinessCategory): BusinessCategoryDto {
		return {
			id: entity.id,
			parent_id: entity.parentId,
			key: entity.key,
			name: entity.name,
			name_translations: entity.nameTranslations,
			requires_description: entity.requiresDescription,
			tags: entity.tags,
			created_at: entity.createdAt?.toISO() ?? undefined,
			updated_at: entity.updatedAt?.toISO() ?? undefined,
		}
	}

	public static toEntities(dtos: BusinessCategoryDto[]): BusinessCategory[] {
		return dtos.map(this.toEntity)
	}
}
